import React from 'react';

import MyWorkConditionalPanel from '@totem/components/portfolio/overview/myWork/conditionalPanel';
import MyWorkContainer from '@totem/components/users/myWork/MyWorkContainer';

const MyWork = () => {
  return (
    <MyWorkContainer>
      <MyWorkConditionalPanel />
    </MyWorkContainer>
  );
};

export default MyWork;
